import { Progress } from 'antd'
import Texts from 'components/Text'
import { usePrepareCart } from 'hooks/usePrepareCart'
import { useMemo } from 'react'
import { formatPriceToNumber } from 'utils/formatters'
import useMediaQuery from '../../../hooks/useMediaQuery'
import { OrderTypes } from '../../../types/OrderTypes'
import { BRANDS_WITH_REQUIRED_FREIGHT, CLASS_WITHOUT_SHIPPING, MOBILE_WIDTH } from '../../../utils/constants'
import { Container, Title } from './styles'

const FREE_SHIPPING_MINIMUM = 2500

interface OrderSummaryProps {
  subtotal: number
  total: number
}

const getShippingCost = (shippingValue: string): number => {
  if (parseFloat(shippingValue) === 0) return 0
  return 145
}

const computeOrderSummary = (items: OrderTypes[], shipping: number, discount: number): OrderSummaryProps => {
  const subtotal = items.reduce((acc, item) => acc + item.unitPrice * item.quantity, 0)
  const total = subtotal - discount
  return { subtotal, total }
}

function Frete() {
  const { lastOrderCreated } = usePrepareCart()
  const isMobile = useMediaQuery(MOBILE_WIDTH)

  if (!lastOrderCreated) return null

  if (lastOrderCreated?.noImportCost) return null

  const { items } = lastOrderCreated

  const isAllSupplements = items.every(
    (item: any) =>
      CLASS_WITHOUT_SHIPPING.includes(item?.product?.class_id || item?.class_id) &&
      !BRANDS_WITH_REQUIRED_FREIGHT.includes(item?.product?.brand_id || item?.brand_id)
  )

  console.log(lastOrderCreated)

  const isFreeShippingFromAPI = parseFloat(lastOrderCreated.shipping || '0') === 0
  const shipping = getShippingCost(lastOrderCreated.shipping || '0')
  const discount = parseFloat(lastOrderCreated.discount || '0')

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const orderSummary = useMemo(
    () => computeOrderSummary(lastOrderCreated.items, shipping, discount),
    [lastOrderCreated.items, shipping, discount]
  )

  console.log(orderSummary)
  console.log(isFreeShippingFromAPI)
  console.log(FREE_SHIPPING_MINIMUM)

  const remainingForFreeShipping = isFreeShippingFromAPI ? 0 : FREE_SHIPPING_MINIMUM - orderSummary.total

  console.log(remainingForFreeShipping)

  return (
    <Container isMobile={isMobile}>
      <Title>{isAllSupplements ? 'FRETE GRÁTIS' : 'CUSTO DE IMPORTAÇÃO'}</Title>
      {!isAllSupplements ? (
        <div className="input">
          <Progress
            percent={
              remainingForFreeShipping <= 0 ? 100 : Math.round((orderSummary.total / FREE_SHIPPING_MINIMUM) * 100)
            }
            strokeColor="rgb(107 123 60 / 1)"
            strokeWidth={16}
            status="active"
            percentPosition={{ align: 'center', type: 'inner' }}
            style={{
              marginTop: '12px'
            }}
          />
          <Texts>
            Faltam <b>{formatPriceToNumber(Math.max(remainingForFreeShipping, 0))}</b> para{' '}
            <b>Custo de importação grátis</b>
          </Texts>
        </div>
      ) : (
        <Texts>Frete grátis para compras exclusivamente de suplementos.</Texts>
      )}
    </Container>
  )
}

export default Frete
